module.exports = __webpack_public_path__ + "img/经验@2x.b328ec6a.png";